import type { Field, QuestionnaireStructure } from '@castoredc/castor_prose';

export const getFieldDefinitions = (questionnaire: QuestionnaireStructure) => {
  // Since PROSE 0.5.0 order of items in fields array is unstable (can change between calls to render),
  // but fields array (string array of field names) in section is stable.
  const unorderedFields = questionnaire.fields;

  const orderedFields: Field[] = [];
  questionnaire.sections.forEach(section =>
    section.fields.forEach(fieldName => {
      const fieldDefinition = unorderedFields.find(uf => uf.name === fieldName);
      if (!fieldDefinition) {
        throw new Error(
          `[Assert failed] Unable to find field definition (fieldName: ${fieldName}))`
        );
      }
      orderedFields.push(fieldDefinition);
    })
  );

  return orderedFields;
};
